const initialState = {
    uiState: {
        authenticationState: {
            loggedIn: false,
            loginPending: false,
            loginFailed: false,
            logoutPending: false,
        },
        componentState: {
            searchResults: { loading: false },
            companies: { loading: false },
            company: { loading: false },
            companyNew: { loading: false, disableForm: false },
            companyEdit: { loading: false, disableForm: false },
            licensePackageLink: { loading: false, disableForm: false },
            administrations: { loading: false },
            administration: { loading: false },
            administrationNew: { loading: false, disableForm: false },
            administrationEdit: { loading: false },
            licenses: { loading: false },
            license: { loading: false },
            licenseWithAllModules: { loading: false },
            licenseNewEdit: { loading: false },
            modules: { loading: false },
            applications: { loading: false, loadFailed: false },
            application: { loading: false },
            applicationNewEdit: { loading: false, disableForm: false },
            websites: { loading: false, loadFailed: false },
            apiUsers: { loading: false, loadFailed: false },
            apiUser: { loading: false },
            apiUserWithAllRoutingSlugs: { loading: false },
            apiUserNewEdit: { loading: false, disableForm: false },
            routingSlugs: { loading: false },
            runningTasks: { loading: false },
            templates: { loading: false },
            template: { loading: false },
            templateNewEdit: { loading: false, disableForm: false },
            templateWithAllRoutingSlugs: { loading: false, disableForm: false },
            jobsOverview: { loading: false },
            failedJobs: { loading: false },
        },
    },
    appData: {
        alerts: false,
        searchResults: false,
        gitInfo: false,
        breadcrumbs: {
            company: {
                id: '',
                name: '',
            },
            license: {
                id: '',
                description: '',
            },
            administration: {
                id: '',
                name: '',
            },
            application: {
                id: '',
                name: '',
            },
            apiUser: {
                id: '',
                name: '',
            },
        },
        companies: false,
        company: false,
        companyNew: false,
        companyEdit: false,
        administrations: false,
        administration: false,
        administrationNew: false,
        administrationEdit: false,
        licenses: false,
        license: false,
        licenseWithAllModules: false,
        licenseNewEdit: false,
        modules: false,
        applications: false,
        application: false,
        applicationNewEdit: false,
        websites: false,
        apiUsers: false,
        apiUser: false,
        apiUserWithAllRoutingSlugs: false,
        apiUserNewEdit: false,
        routingSlugs: false,
        runningTasks: false,
        templates: false,
        template: false,
        templateNewEdit: false,
        templateWithAllRoutingSlugs: false,
        jobsOverview: false,
    },
};
export default initialState;
